<!-- komponenta ki izpiše vse podatke o Coachu. Pobere jih iz coaches arraya (coaches/index.js) -->
<template>
  <li>
    <h3>{{ fullName }}</h3>
    <h4>${{ rate }}/hour</h4>

    <div>
      <base-badge v-for="area in areas" :key="area" :type="area" :title="area"></base-badge>
    </div>

    <div class="actions">
      <!-- za dinamično bindanje preko computed uproabi : - :to -->
      <base-button mode="outline" link :to="coachContactLink"
        >Contact</base-button>
      <base-button link :to="coachDetailsLink">View Details</base-button>
    </div>
  </li>
</template>

<script>
export default {
  // podatke dobiš preko props, ki se nahaja v CoachesList v v-for.
  // ti podatki so že lokalno v CoachesList zato ne rabimo Vuex-a.
  props: ['id', 'firstName', 'lastName', 'areas', 'rate'],
  computed: {
    fullName() {
      return this.firstName + ' ' + this.lastName;
    },
    // preko id, tako zgradiš dinemičen link.
    // /cocaches/c1/contact
    coachContactLink() {
      return this.$route.path + '/' + this.id + '/contact';
    },
    // this.$route.path = /coaches/
    // v primeru če v router zamenjaš ime poti (ni nujno)
    coachDetailsLink() {
      return this.$route.path + '/' + this.id;
    },
  },
};
</script>

<style scoped>
li {
  margin: 1rem 0;
  border: 1px solid #424242;
  border-radius: 12px;
  padding: 1rem;
}

h3 {
  font-size: 1.5rem;
}

h3,
h4 {
  margin: 0.5rem 0;
}

div {
  margin: 0.5rem 0;
}

.actions {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  h3 {
    font-size: 1.2rem;
  }
}
</style>
